export enum Storage {
  LOCAL = "localstorage",
  SESSION = "sessionstorage",
}
